import { StatusLabel, StatusLabelTypes } from '@factorialco/deprecated-design-system'
import { DocumentsSignatureStatusEnum } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { documentSignatureStatusLabel } from 'modules/documents/lib/Documents'

interface Props {
  status: DocumentsSignatureStatusEnum
}

const statusToStatusLabelType: Record<DocumentsSignatureStatusEnum, StatusLabelTypes> = {
  ['pending']: 'warning',
  ['partially_signed']: 'info',
  ['completed']: 'positive',
  ['declined']: 'critical',
  ['bounced_email']: 'critical',
  ['cancelled']: 'neutral',
  ['error']: 'critical',
  ['expired']: 'critical',
}

const SignatureStatusTag = ({ status }: Props) => {
  return (
    <StatusLabel ellipsis type={statusToStatusLabelType[status]}>
      {documentSignatureStatusLabel(status)}
    </StatusLabel>
  )
}

export default observer(SignatureStatusTag)
